import httpClient from "@/core/axios";

export default {
    namespaced: true,
    state: {
        phones: []
    },
    getters: {
        phones(state) {
            return state.phones;
        },
        primary(state) {
            return state.phones.find(phone => phone.is_primary);
        }
    },
    actions: {
        async fetch(context) {
            return httpClient
                .get("/api/guest/app/:app_uuid/user/phones")
                .then(data => context.commit("SET_PHONES", data));
        },
        async create(context, { number, is_primary }) {
            return httpClient
                .post("/api/guest/app/:app_uuid/user/phones", {
                    number,
                    is_primary
                })
                .then(data => context.commit("SET_PHONES", data));
        },
        async update(context, { id, number, is_primary }) {
            return httpClient
                .patch(`/api/guest/app/:app_uuid/user/phones/${id}`, {
                    number,
                    is_primary
                })
                .then(data => context.commit("SET_PHONES", data));
        },
        async delete(context, { id }) {
            return httpClient
                .delete(`/api/guest/app/:app_uuid/user/phones/${id}`)
                .then(data => context.commit("SET_PHONES", data));
        }
    },
    mutations: {
        SET_PHONES(state, data) {
            state.phones = data;
        }
    }
};
